<template>
    
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :okButtonProps="{ props: {disabled: disableSubmit} }"
      :maskClosable="maskClosable"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t('关闭')">
        <a-spin :spinning="confirmLoading">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <a-row :gutter="48">
              <a-col :span="12">
                    <a-form-model-item :label="$t('模板名称')"  prop="templateName">
                    <a-input v-model="model.templateName" :placeholder="$t('请输入模板名称')"  ></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('模板类型')"  prop="flag">
                    <a-select
                        v-model="model.flag"
                        style="width: 100%"
                        :placeholder="$t('请选择模板类型')"
                        >
                        <a-select-option v-for="(item,key) in messageTypeObj" :value="Number(key)" :key="key">
                            {{ $t(item) }}
                        </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="appId"  prop="keyId">
                    <a-input v-model="model.keyId" :placeholder="$t('请输入appId')"  ></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="appSecret" prop="keySecret">
                    <a-input v-model="model.keySecret" :placeholder="$t('请输入appSecret')"  ></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('模板Id')" prop="templateCode">
                    <a-input v-model="model.templateCode" :placeholder="$t('请输入模板id')" style="width: 100%" ></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('签名')" prop="signName" v-if="model.flag == 1">
                    <a-input v-model="model.signName" :placeholder="$t('请输入签名')" style="width: 100%" ></a-input>
                    </a-form-model-item>
                </a-col>

                <a-col :span="24">
                    <a-form-model-item :label="$t('备注')"  prop="remark">
                        <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
</template>
<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import {messageTypeObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'MessageBaseModal',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
        },
        messageTypeObj,
        maskClosable:false,
        title:this.$t('操作'),
        visible: false,
        disableSubmit:false,
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterMessageBase/add",
          edit: "/jeecg-charge/meter/meterMessageBase/edit"
        }
      }
    },
    computed: {
      rules() {
        return {
          templateName:[{ required: true, message: this.$t('请输入模板名称')}],
          keyId:[{ required: true, message: this.$t('请输入appId')}],
          keySecret:[{ required: true, message: this.$t('请输入appKey')}],
          templateCode:[{ required: true, message: this.$t('请输入模板id')}],
          signName:[{ required: true, message: this.$t('请输入签名')}],
          flag:[{ required: true, message: this.$t('请选择模板类型')}],
        }
      },
    },
    created () {
    },
    methods: {
        
      add () {
          console.log("添加")
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if(valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                this.close()
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      close () {
        this.$emit('close');
        this.$refs.formModal.resetFields()
        this.model = this.$options.data.call(this).model
        this.disableSubmit = false;
        this.visible = false;
      },

      handleCancel () {
        this.close();
      }
    }
  }
</script>